import { render, staticRenderFns } from "./UsagesMatchingList.vue?vue&type=template&id=0019dffd&scoped=true&"
import script from "./UsagesMatchingList.vue?vue&type=script&lang=js&"
export * from "./UsagesMatchingList.vue?vue&type=script&lang=js&"
import style0 from "./UsagesMatchingList.vue?vue&type=style&index=0&id=0019dffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019dffd",
  null
  
)

export default component.exports